// extracted by mini-css-extract-plugin
export default {"card":"AdvantageCard_card__rXtKX","icon":"AdvantageCard_icon__iktmN","p":"AdvantageCard_p__dQR4F"};